import { motion, useReducedMotion } from "framer-motion";
import { Reveal } from "@/components/site/Motion";
import { useEnquiry } from "@/components/site/EnquiryContext";

export const SectionAction = ({ section, label = "Discuss your project", category, prefill, dark = false, className = "mt-10" }) => {
  const { openEnquiry } = useEnquiry();
  return (
    <div className={className}>
      <button type="button" className={`btn-glass ${dark ? "btn-on-dark" : ""}`} onClick={() => openEnquiry(`${section} section — ${label}`, { category, prefill })} data-testid={`${section}-cta-btn`}>
        {label}
      </button>
    </div>
  );
};

export const ExtLabel = ({ children, as: Tag = "p", className = "" }) => {
  const reduce = useReducedMotion();
  const cls = `eyebrow ext-head whitespace-nowrap ${className}`;
  if (reduce) return <Tag className={cls}>{children}</Tag>;
  const M = motion[Tag];
  return (
    <M className={cls} initial={{ opacity: 0, x: -24 }} whileInView={{ opacity: 1, x: 0 }} viewport={{ once: true, amount: 0.5 }} transition={{ duration: 0.4, ease: [0.22, 1, 0.36, 1] }}>
      {children}
    </M>
  );
};

const Head = ({ id, title, lead, light }) => (
  <Reveal className="mb-8 max-w-3xl md:mb-10">
    <h2 id={`${id}-title`} className={`text-3xl font-bold leading-[1.12] md:text-4xl lg:text-[2.6rem] ${light ? "ext-head text-white" : "text-[#102A43]"}`}>{title}</h2>
    {lead && <p className={`mt-4 text-base leading-relaxed md:text-lg ${light ? "ext-head text-[#E3EAF0]" : "text-[#2B3642]"}`}>{lead}</p>}
  </Reveal>
);

// variant: "panel" (white card), "glass" (translucent card that fades out at the bottom), "transparent" (content on the background)
export const Section = ({ id, eyebrow, title, lead, action, variant, transparent = false, tight = false, children }) => {
  const v = transparent ? "transparent" : variant || "panel";
  return (
    <section id={id} aria-labelledby={`${id}-title`} className={`${tight ? "first-gap" : "section-gap"} relative`} data-testid={`section-${id}`}>
      <div className="panel-inner"><ExtLabel>{eyebrow}</ExtLabel></div>
      {v === "transparent" ? (
        <div className="container-x mt-4">
          <div className="panel-align"><Head id={id} title={title} lead={lead} light /></div>
          {children}
        </div>
      ) : (
        <div className={`${v === "glass" ? "panel-glass panel-fade" : "panel"} mt-4`} data-testid={`panel-${id}`}>
          <div className="panel-inner">
            <Head id={id} title={title} lead={lead} light={v === "glass"} />
            {children}
            {action && <SectionAction section={id} {...action} />}
          </div>
        </div>
      )}
    </section>
  );
};

export const Spec = ({ items }) => (
  <ul className="grid gap-2.5 text-[15px] text-[#151A20]">
    {items.map((s) => (
      <li key={s} className="flex gap-3"><span aria-hidden="true" className="mt-[11px] h-px w-3 shrink-0 bg-[#7890A5]" />{s}</li>
    ))}
  </ul>
);
